import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const About: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <section id="about" className="py-20 md:py-32 bg-gradient-to-b from-[#0b0807] to-[#14100e] relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Main Content */}
          <motion.div
            ref={ref}
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="text-center mb-14 md:mb-24"
          >
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1.2, delay: 0.2, ease: "easeOut" }}
              className="text-4xl md:text-7xl font-light mb-8 md:mb-12 leading-none tracking-tight text-amber-50"
            >
              Geleneksel
              <br />
              <span className="font-normal text-amber-300/80">Lezzetler</span>
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1.2, delay: 0.4, ease: "easeOut" }}
              className="text-base sm:text-lg md:text-2xl text-amber-100/75 mb-10 md:mb-16 max-w-3xl mx-auto leading-relaxed font-light"
            >
              1992 yılından bu yana Kaçkar Karafırın olarak, geleneksel fırıncılık 
              sanatını modern tekniklerle birleştiriyoruz.
            </motion.p>
          </motion.div>

          {/* Manifesto Text */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 0.6, ease: "easeOut" }}
            className="text-center mb-14 md:mb-32"
          >
            <motion.p
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1.2, delay: 0.8, ease: "easeOut" }}
              className="text-xl md:text-4xl font-light text-amber-100/85 leading-relaxed max-w-4xl mx-auto"
            >
              "Her lokma bir hikaye, her ekmek bir anı. 
              <br />
              Geleneksel tariflerimizi koruyarak, 
              <br />
              gelecek nesillere aktarıyoruz."
            </motion.p>
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 1, ease: "easeOut" }}
            className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16"
          >
            <div className="text-center rounded-2xl border border-amber-100/10 bg-amber-50/[0.02] p-8">
              <div className="text-5xl font-light text-amber-100 mb-4">25+</div>
              <div className="text-amber-100/70 font-light">Yıllık Deneyim</div>
            </div>
            <div className="text-center rounded-2xl border border-amber-100/10 bg-amber-50/[0.02] p-8">
              <div className="text-5xl font-light text-amber-100 mb-4">10K+</div>
              <div className="text-amber-100/70 font-light">Mutlu Müşteri</div>
            </div>
            <div className="text-center rounded-2xl border border-amber-100/10 bg-amber-50/[0.02] p-8">
              <div className="text-5xl font-light text-amber-100 mb-4">100+</div>
              <div className="text-amber-100/70 font-light">Özel Tarif</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About; 